import { OntarioOperationCost } from '../operation-cost'

export const OperationCost = {
  ...OntarioOperationCost,
} as const
